import { useCallback, useEffect, useRef, type ReactNode } from 'react'

import { RecordReachProvider, type RecordReachLookup } from '@/shared/access'
import { parseCursorPage } from '@/shared/api/paging'
import { useApiClient } from '@/shared/api/use-api-client'

import { parseUserName, userNamesApi, userRoute } from './user'

/**
 * Links a person's name only for a caller who may open them: the User Profile names, asked for the
 * linked ids, answer with those in their user read reach, as User Details does.
 */
export function UserReachProvider(props: { readonly children: ReactNode }) {
  const client = useApiClient()
  // Kept current without changing the lookup, which would ask again: the client changes when sign-in settles.
  const api = useRef(client)
  useEffect(() => {
    api.current = client
  }, [client])

  const lookup = useCallback<RecordReachLookup>(async (ids) => {
    const query = new URLSearchParams({ ids: ids.join(',') })
    const found = parseCursorPage(await api.current.get(`${userNamesApi}?${query.toString()}`), parseUserName)
    return new Set(found.data.map((name) => name.id))
  }, [])

  return (
    <RecordReachProvider route={userRoute} lookup={lookup}>
      {props.children}
    </RecordReachProvider>
  )
}
